import {
  Academic as AcademicIcon,
  Basics as BasicsIcon,
  Research as ResearchIcon,
  PreviousEmployment as PreviousEmploymentIcon,
  Parallel,
  Upload,
  Edit,
} from "../../Components/Icon";

import ProposalOverview from "../../Pages/GeneralInformation/ProposalOverview";
import Basics from "../../Pages/GeneralInformation/Basics";
import ParallelFunding from "../../Pages/GeneralInformation/ParallelFunding";
import Research from "../../Pages/GeneralInformation/Research";
import Academic from "../../Pages/GeneralInformation/Academic";
import PreviousEmployment from "../../Pages/GeneralInformation/PreviousEmployment";
import UploadDocs from "../../Pages/GeneralInformation/UploadDocs";
import ApplicantDocs from "../../Pages/GeneralInformation/ApplicantDocs";

const navigation = ({ preProposal } = { preProposal: false }) => {
  return {
    header: "Applicant Details",
    links: [
      {
        text: `${preProposal ? "Pre-proposal" : "Proposal"} Overview`,
        icon: Edit,
        route: "overview",
        component: ProposalOverview,
        preProposal: true,
      },
      {
        text: "Basics",
        icon: BasicsIcon,
        route: "basics",
        component: Basics,
        preProposal: true,
      },
      {
        text: "Research Interest",
        icon: ResearchIcon,
        route: "research",
        component: Research,
      },
      {
        text: "Academic Background",
        icon: AcademicIcon,
        route: "academic",
        component: Academic,
      },
      {
        text: "Previous Employment",
        icon: PreviousEmploymentIcon,
        route: "prevemp",
        component: PreviousEmployment,
      },
      {
        text: "Parallel funding",
        icon: Parallel,
        route: "funding",
        component: ParallelFunding,
      },
      {
        text: "Upload Docs",
        icon: Upload,
        route: "upload",
        component: UploadDocs,
        preProposal: true,
      },
      {
        text: "Applicant Docs",
        icon: Upload,
        route: "applicantdocs",
        component: ApplicantDocs,
        preProposal: true,
      },
    ],
  };
};
export default navigation;
